<template>
  <div class="order-item" @click="onItemClick">
    <div class="space"></div>
    <div class="subtitle-info">
      <div class="order-title">
        订单编号
        <span v-clipboard:copy="order.order_no" v-clipboard:success="onCopied">
          {{ order.order_no }}
          <i class="pay-state" v-if="isSearching">{{isSearching}}</i>
        </span>
      </div>
      <div>
        订单状态
        <span :class="statusClass">{{ order.order_status_title }}</span>
        <span :class="{'ic-arrow-yellow': order.need_action}"></span>
      </div>
    </div>
    <div class="info-cont" v-if="isStaff">
      <div>
        <span class="label">下单时间</span>
        <span>{{ order.create_time }}</span>
      </div>
      <div>
        <span class="label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>
        <span>{{ order.customer_name }}</span>
      </div>
      <div>
        <span class="label">套餐名称</span>
        <span>{{ order.product_pkg_title }}</span>
      </div>
      <div>
        <span class="label">购买价格</span>
        <span>{{ order.pay_price }}元</span>
      </div>
      <div class="mt-5 top-dashed-line center-t" v-if="this.order.is_delete" @click.stop="toDelete">
        <span>
          <a href="javascript:void(0);" class="delete-red">删除</a>
        </span>
      </div>
    </div>
    <div class="info-cont" v-if="isCustomer">
      <div>
        <span class="label">套餐名称</span>
        <span>{{ order.product_pkg_title }}</span>
      </div>
      <div>
        <span class="label">购买价格</span>
        <span>{{ order.pay_price }}元</span>
      </div>
      <div v-show="!this.order.has_signed">
        <span class="label">服务时长</span>
        <span>{{ order.service_period }}个月</span>
      </div>
      <div v-show="this.order.has_signed">
        <span class="label">服务时间</span>
        <span>{{ order.service_start_date }} 至 {{order.service_end_date}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from "mint-ui";
export default {
  name: "OrderItem",
  props: ["order", "role", "isSearching"],
  data: () => ({}),
  computed: {
    statusClass() {
      return "share";
    },
    isCustomer() {
      return this.role === "customer";
    },
    isStaff() {
      return this.role === "staff";
    }
  },
  methods: {
    onCopied() {
      this.toast("已复制");
    },
    toSurvey() {
      this.PostSurvey(this.order, rs => {
        if (rs.data.has_survey === true) {
          this.order.has_survey = true;
          this.toast("已匹配到您上次填写的问卷, 请去签订合同");
          window.location.reload();
        }
      });
    },
    toTransFillIn() {
      if (this.order.is_paying === true) {
        this.$store.dispatch("setOrder", { order: this.order });
        this.$router.push("/trans/accounts");
      }
    },
    toSignContract() {
      this.SignContract(this.order, rs => {
        this.order.has_signed = true;
        this.toCompletePage(true);
      });
    },
    toDelete() {
      MessageBox.confirm("删除是不可恢复的，您确定删除该订单吗？").then(
        action => {
          console.log(action);
          if (action === "confirm") {
            let url = "/api/orders/" + this.order.order_no;
            this.loading("正在删除...");
            this.$http.delete(url).then(
              response => {
                this.loadingHide();
                var rs = response.body;
                if (rs.code === 0) {
                  this.toast("删除成功");
                  window.location.reload();
                } else {
                  this.handleHttpError(response);
                }
              },
              response => {
                console.log(response);
                this.handleHttpError(response);
              }
            );
          }
        },
        action => {}
      );
    },
    toCustomerPay() {
      if (this.order.is_trans === true) {
        if (this.order.order_status === 33) {
          if (this.order.is_staff_help === 1) {
            MessageBox.alert(
              "您的服务助理正在录入查账信息，稍后TA会联系您完成后续操作"
            );
          }
          this.$router.push("/my/orders/" + this.order.order_no);
        } else if (this.order.order_status === 34) {
          this.$router.push("/orders/verify/" + this.order.order_no);
        } else {
          if (this.order.is_staff_help === 1) {
            MessageBox.alert(
              "您的服务助理正在录入查账信息，稍后TA会联系您完成后续操作"
            );
            this.$router.push("/my/orders/" + this.order.order_no);
          } else {
            // 自行填写查账
            this.rememberOrder(this.order.order_no, "TransList", rs => {
              this.$router.push("/trans/" + this.order.order_no);
            });
          }
        }
      } else {
        if (this.order.order_price > 0 && this.order.paid_price <= 0) {
          this.rememberOrder(this.order.order_no, "Payways", rs => {
            window.location.href = "?#/pay/ways/" + this.order.order_no;
          });
        } else {
          if (this.order.order_status === 34) {
            this.$router.push("/orders/verify/" + this.order.order_no);
          } else if (this.order.pay_kind === 20) {
            // 分次支付
            this.rememberOrder(this.order.order_no, "PaySplit", rs => {
              window.location.href = "?#/pay/split/" + this.order.order_no;
            });
          }
        }
      }
    },
    toCustomerSign() {
      if (this.order.order_status === 33) {
        if (this.order.pay_status === 11) {
          MessageBox.alert(
            "您的服务助理正在录入查账信息，稍后TA会联系您完成后续操作"
          );
        } else {
          MessageBox.alert(
            "请耐心等候我司财务核实查账信息, 您的专属服务助理会联系您签订合同，若有疑问请联系专属服务助理"
          );
        }
        this.$router.push("/my/orders/" + this.order.order_no);
      } else {
        this.toSignContract();
      }
    },
    toCustomerView() {
      if (this.order.to_select_teacher === true) {
        if (this.order.pay_status === 60) {
          MessageBox.alert(
            "请耐心等候我司财务核实查账信息, 您的专属服务助理会联系您签订合同，若有疑问请联系专属服务助理"
          );
        } else if (this.order.pay_status === 30) {
          this.$router.push("/orders/select/teacher/" + this.order.order_no);
        } else if (this.order.pay_status === 70) {
          this.toCustomerPay();
        }
      } else if (this.order.has_signed === true) {
        if (this.order.service_status === 1) {
          this.$router.push("/my/orders/" + this.order.order_no);
        } else {
          this.$router.push("/orders/complete/" + this.order.order_no);
        }
      } else if (this.order.is_paying === true) {
        this.toCustomerPay();
      } else if (this.order.is_surveying === true) {
        this.toSurvey();
      } else if (this.order.is_signing === true) {
        this.toCustomerSign();
      } else if (this.order.has_finished === true) {
        this.$router.push("/my/orders/" + this.order.order_no);
      } else if (this.order.pay_status === 60) {
        MessageBox.alert(
          "请耐心等候我司财务核实查账信息, 您的专属服务助理会联系您签订合同，若有疑问请联系专属服务助理"
        );
      } else {
        this.rememberOrder(this.order.order_no, "OrderConfirm", rs => {
          this.$router.push("/orders/confirm/" + this.order.order_no);
        });
      }
    },
    onItemClick() {
      // console.log('view: ', this.order)
      this.$store.dispatch("setOrder", { order: this.order });
      this.$store.dispatch("setTransList", { items: [] });
      if (this.role === "customer") {
        this.toCustomerView();
      } else {
        this.$router.push("/orders/" + this.order.order_no);
      }
    }
  }
};
</script>

<style scoped>
.pay-state {
  font-size: 10px;
  height: 16px;
  line-height: 16px;
  padding: 3px;
  background: #439aff;
  color: #fff;
  font-style: normal;
  font-weight: 400;
  border-radius: 4px;
  margin-left: 6px;
  position: relative;
  top: -3px;
}
</style>



// WEBPACK FOOTER //
// OrderItem.vue?181db4eb